export enum VideoHost {
  YOUTUBE = 'YOUTUBE'
}
